import { useParams } from "react-router";
import { Canvas } from "../editor/Canvas.tsx";

export function EditorRoute() {
  const { documentId } = useParams();
  const id = documentId ?? "draft";
  return (
    <div className="h-full min-h-0">
      <Canvas documentId={id} />
    </div>
  );
}
